// import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Possible statuses:
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
 */

export const UserStatusCell = ({ status = 'active' }: { status?: string }) => {
  const { t } = useTranslation();

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'inactive':
        return 'bg-yellow-100 text-red-800';
      case 'suspended':
        return 'bg-red-100 text-yellow-800';
      case 'deleted':
        return 'bg-gray-100 text-gray-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span
      className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(
        status
      )}`}
    >
      {t(`status.${status.toLowerCase()}`)}
    </span>
  );
};
